import { useCallback } from 'react';
import type { StatsigUpdateDetails, StatsigUser } from '@statsig/client-core';

import { useStatsigClient } from '@rover/rsdk/src/modules/Statsig';

import { Logger } from '../Logging';

import type { RoverStatsigUser } from './types';
import { useRoverStatsigUser } from './useRoverStatsigUser';
import { createUserPayload } from './utils';

type UseRoverStatsigContextReturn = {
  updateStatsigUser: (fields: RoverStatsigUser) => Promise<void | StatsigUpdateDetails>;
  roverStatsigUser: RoverStatsigUser;
  statsigUser: StatsigUser;
};

const useRoverStatsigContext = (): UseRoverStatsigContextReturn => {
  const { client } = useStatsigClient();
  const { roverStatsigUser } = useRoverStatsigUser();

  const updateStatsigUser = useCallback(
    (fields: RoverStatsigUser): Promise<void | StatsigUpdateDetails> =>
      client
        .updateUserAsync(
          createUserPayload(
            {
              ...roverStatsigUser,
              ...fields,
            },
            client.getContext().user
          )
        )
        .catch(Logger.error),
    [client, roverStatsigUser]
  );

  return {
    updateStatsigUser,
    roverStatsigUser,
    statsigUser: client.getContext().user,
  };
};

export default useRoverStatsigContext;
